import React from 'react';
import Select, { ValueType } from 'react-select';

import './select.scss';

const SelectComponent = (props: {
  isMulti: boolean;
  options: Array<any>;
  value: ValueType<any>;
  onChange: Function;
  isDisabled: boolean;
  isClearable?: boolean;
  placeholder: string;
}) => {
  const { isMulti, options, value, onChange, isDisabled, isClearable = true, placeholder } = props;

  return (
    <Select
      className={isMulti ? 'left-panel-select-multi-container' : 'left-panel-select-container'}
      classNamePrefix={isMulti ? 'left-panel-select-multi' : 'left-panel-select'}
      isMulti={isMulti}
      options={options}
      value={value}
      onChange={(e) => onChange(e)}
      isClearable={isClearable}
      isDisabled={isDisabled}
      placeholder={placeholder}
      menuPlacement='auto'
    />
  );
};

export default SelectComponent;
